export enum ViewStock {
  ViewMyStore = 'ViewMyStore',
  ViewOtherStore = 'ViewOtherStore'
}
